import { render, staticRenderFns } from "./surface_app.vue?vue&type=template&id=1d284ee6&scoped=true&"
import script from "./surface_app.vue?vue&type=script&lang=ts&"
export * from "./surface_app.vue?vue&type=script&lang=ts&"
import style0 from "./surface_app.vue?vue&type=style&index=0&id=1d284ee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d284ee6",
  null
  
)

export default component.exports